import { getUserInfo, login, logout as logoutApi } from '@/api/user'
import router from '@/router'
import type { LockInfo, LoginParam, NavTab, UserInfo } from '@/types/user'
import { transformToRoutes } from '@/utils/dynamicRoutes'
import { setItem } from '@/utils/storage'
import { defineStore } from 'pinia'

// 你可以对 `defineStore()` 的返回值进行任意命名，但最好使用 store 的名字，同时以 `use` 开头且以 `Store` 结尾。(比如 `useUserStore`，`useCartStore`，`useProductStore`)
// 第一个参数是你的应用中 Store 的唯一 ID。
export const useUserInfoStore = defineStore('userInfo', {
  state: () => {
    // 用户信息
    return {
      user: {} as UserInfo,
      collapse: false, // 菜单折叠状态
      lockInfo: { password: '', isLockScreen: false } as LockInfo,
      tabList: [] as NavTab[]
    }
  },
  getters: {
    avatar: (state) => {
      return state.user.avatar || '/images/avatar_boy.jpeg'
    }
  },
  actions: {
    // 登录获取token
    async login(loginForm: LoginParam) {
      console.log('登录获取token')
      const token = await login(loginForm)
      console.log('开始设置token', token)
      setItem('token', token)
    },
    // 获取用户信息
    async getUserInfo() {
      console.log('获取用户信息')
      this.user = await getUserInfo()
      this.setAsyncRoutes()
    },

    // 退出登录
    async logout() {
      try {
        await logoutApi()
      } catch (e) {
        // ignore
      }
      window.localStorage.clear()
      this.$reset()
    },

    // 切换菜单折叠状态
    switchFolding() {
      this.collapse = !this.collapse
    },
    // 添加动态路由
    async setAsyncRoutes() {
      // 添加动态路由
      if (!this.user || !this.user.menus) return
      const routerList = transformToRoutes(this.user.menus)
      routerList.forEach((route) => {
        router.addRoute('admin', route)
      })
      // 可能需要等待路由更新完成
      router.isReady()
    }
  },

  persist: true
})
